//
import Model from '@/models/Model'

/**
 * This class describes a pch provider debt to pay pending.
 *
 * @class      PchProviderDebtToPayPending (name)
 */
export default class PchProviderDebtToPayPending extends Model {

	/**
	 * { property_description }
	 *
	 * @type       {<type>}
	 */
	get purchase_number() {
		return this.pch_purchase_invoice_id ? this.pch_purchase_invoice.invoice_number : this.pch_purchase_debit_note.number
	}

	/**
	 * { property_description }
	 *
	 * @type       {<type>}
	 */
	get purchase_type() {
		return this.pch_purchase_invoice_id ? 'Factura' : 'Nota de debito'
	}

	/**
	 * Resets the object.
	 *
	 * @return     {Object}  { description_of_the_return_value }
	 */
	reset() {

		//
		this.amount = this.total - this.total_paid	

		//
		return this
	}

  /**
   * { function_description }
   *
   * @return     {string}  { description_of_the_return_value }
   */
  resource() {
    return 'pch_provider_debt_to_pay_pending'
  }
}